import React from "react";

const Mp3Icon = ({ show }) => {
  return (
    <>
      <div onClick={show} className="icon mp3">
        <span>Mp3 Player</span>
      </div>
    </>
  );
};

export default Mp3Icon;
